import * as React from "react";
import { Badge } from "@/components/ui/badge";
const categories = ["Klarifikasi Resmi", "Cek Fakta"];
export default function LabelKategori() {
  return <section id="label-kategori" className="w-full bg-background py-4 px-4 md:px-6 lg:px-8 flex flex-wrap items-center justify-start gap-2 md:gap-3 lg:gap-4">
      {categories.map((category, i) => <Badge key={i} data-index={i} className="bg-[#EB7C2D] text-white hover:bg-[#EB7C2D]/90 border-transparent rounded-[4px] text-[12px] md:text-[14px] lg:text-[16px] uppercase font-sans tracking-wide px-3 py-1 shadow-none">
          {category}
        </Badge>)}
    </section>;
}